<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <!-- <cst-form-box list-url="/cstTask" :id="id" task-type="task" :form-type="formType" @add="onAdd"></cst-form-box> -->
      <cst-form-box
        list-url="/cstTask"
        :id="id"
        task-type="task"
        :form-type="formType"
        @add="onAdd"
        @edit="onEdit"
      ></cst-form-box>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import router from '@/router';
import CstFormBox from '../../components/CstFormBox.vue';

export default {
  name: 'CSTForm',
  components: {
    CstFormBox
  },
  async mounted() {
    if (this.$route.name === 'cst-task-new') {
      this.formType = 'new';
      this.id = null;
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;

      await this.getOne({
        type: 'task',
        id: this.id,
        router
      });
    }
  },
  data() {
    return {
      formType: '',
      id: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Add New Task' : 'Update Task';
    },
    ...mapState('cst', ['loading'])
  },
  methods: {
    ...mapActions('cst', ['getOne', 'postOne', 'patchOne']),
    onAdd({ task }) {
      this.postOne({
        task,
        router,
        redirectUrl: '/cstTask'
      });
    },
    onEdit({ task }) {
      this.patchOne({
        type: 'task',
        id: this.id,
        task,
        router,
        redirectUrl: '/cstTask'
      });
    }
  }
};
</script>
